<template>
  <div>
    <!-- 商品管理业务汇总 -->
    <baseBreadcrumb :page="$t('message.productManagementBusinessSummary')" :menu="$t('message.customerManagement')">
    </baseBreadcrumb>
    <!-- 主体 -->
    <div class="body">
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 客户ID -->
          <div class="item">
            <el-input v-model="datas.id" :placeholder="$t('message.userID')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 客户名 -->
          <div class="item">
            <el-input v-model="datas.realname" :placeholder="$t('message.userName')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <div class="btn">
            <!-- 搜索 -->
            <el-button type="primary" @click="search">
              {{ $t("message.search") }}
            </el-button>
            <!-- 重置 -->
            <el-button @click="reset">
              {{ $t("message.reset") }}
            </el-button>
            <!-- 高级筛选 -->
            <el-button @click="showSearch = !showSearch" v-if="!showSearch">
              {{ $t("message.advancedFilter") }}
              <i class="el-icon-caret-right"></i>
            </el-button>
            <!-- 收起 -->
            <el-button @click="showSearch = !showSearch" v-else type="primary">
              {{ $t("message.putAway") }}
              <i class="el-icon-caret-top"></i>
            </el-button>
          </div>
          <!-- 操作 -->
        </div>
      </div>
      <!-- 高级筛选 -->
      <el-collapse-transition>
        <div class="advancedScreening" v-show="showSearch">
          <advancedScreening ref="advancedScreening" />
        </div>
      </el-collapse-transition>
      <!-- 列表 -->
      <div class="table" v-if="show">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange"
          ref="multipleTable" @cell-click="labelSelection">
          <el-table-column type="selection" width="50" align="center">
          </el-table-column>
          <!-- 客户信息-->
          <el-table-column align="center" :label="$t('message.userInfo')">
            <template slot-scope="scope">
              <p>ID:{{ scope.row.id }}</p>
              <p>{{ scope.row.realname }}</p>
            </template>
          </el-table-column>
          <!-- 操作员 -->
          <el-table-column align="center" :label="$t('message.operator')" width="120">
            <template slot-scope="scope">
              <div class="name">
                <span>{{ $t("message.salesman") }}:</span>{{ scope.row.y_admin != null ? scope.row.y_admin.realname : ''
                }}
              </div>
              <div class="name">
                <span>{{ $t("message.buyer") }}:</span>{{ scope.row.g_admin != null ? scope.row.g_admin.realname : '' }}
              </div>
              <div class="name">
                <span>{{ $t("message.distributionMember") }}:</span>
                {{ scope.row.p_admin != null ? scope.row.p_admin.realname : '' }}
              </div>
            </template>
          </el-table-column>
          <!-- 客户等级 -->
          <el-table-column align="center" :label="$t('message.clientGrade')">
            <template slot-scope="scope">
              <p>{{ scope.row.level_name }}</p>
            </template>
          </el-table-column>
          <!-- 客户属性 -->
          <el-table-column align="center" :label="$t('message.customerProperty')">
            <template slot-scope="scope">
              <attributeName :name="scope.row.attribute_name" />
            </template>
          </el-table-column>
          <!-- 累计出货金额 -->
          <el-table-column align="center" :label="$t('message.accumulatedShipmentAmount')">
            <template slot-scope="scope">
              <p>{{ scope.row.goods_amount }}</p>
            </template>
          </el-table-column>
          <!-- 进行中商品 -->
          <el-table-column align="center" :label="$t('message.productsInProgress')">
            <template slot-scope="scope">
              <router-link :to="{ name: 'productManagementV2', query: { user_id: scope.row.id } }"
                target="_blank">
                <p>{{ scope.row.ordering_product_count }}</p>
              </router-link>
            </template>
          </el-table-column>
          <!-- 历史商品 -->
          <el-table-column align="center" :label="$t('message.historicalProducts')">
            <template slot-scope="scope">
              <router-link :to="{ name: 'productManagementV2', query: { user_id: scope.row.id } }"
                target="_blank">
                <p>{{ scope.row.ordered_product_count }}</p>
              </router-link>
            </template>
          </el-table-column>
          <!-- 待绑定链接数 -->
          <el-table-column align="center" :label="$t('message.pendingBindingLinksCount')"
            class-name="basicInfoPendingMaintenance">
            <template slot-scope="scope">
              <router-link :to="{ name: 'productManagementV2', query: { user_id: scope.row.id } }"
                target="_blank">
                <p>{{ scope.row.client_product_temp_count }}</p>
              </router-link>
            </template>
          </el-table-column>
          <!-- 管理番号数量 -->
          <el-table-column align="center" :label="$t('message.managementNumberCount')"
            class-name="managementNumberCount">
            <template slot-scope="scope">
              <router-link :to="{ name: 'productManagementV2', query: { user_id: scope.row.id } }"
                target="_blank">
                <p>{{ scope.row.client_product_count }}</p>
              </router-link>
            </template>
          </el-table-column>
          <!-- 已维护基础信息 -->
          <el-table-column align="center" :label="$t('message.maintainedBasicInfo')" class-name="maintainedBasicInfo">
            <template slot-scope="scope">
              <router-link :to="{ name: 'productManagementV2', query: { user_id: scope.row.id } }"
                target="_blank">
                <p>{{ scope.row.client_product_complete_count }}</p>
              </router-link>
            </template>
          </el-table-column>
          <!-- 基础信息待维护 -->
          <el-table-column align="center" :label="$t('message.basicInfoPendingMaintenance')"
            class-name="basicInfoPendingMaintenance">
            <template slot-scope="scope">
              <router-link :to="{ name: 'productManagementV2', query: { user_id: scope.row.id } }"
                target="_blank">
                <p>{{ scope.row.client_product_waiting_count }}</p>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import advancedScreening from "./components/advancedScreening";
export default {
  components: { advancedScreening, },
  data() {
    return {
      datas: {
        page: 1,
        pageSize: 10,
        id: "",
        realname: "",
      },
      tableData: [],
      total: 0,
      selectList: [],
      show: true,
      showSearch: false,
    };
  },
  created() {
    this.clientProductList();
  },
  methods: {
    clientProductList() {
      this.$api.productManagementApi.clientProductList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.clientProductList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.clientProductList();
    },
    // 搜索
    search() {
      let data = this.$refs.advancedScreening.option(false);
      let isDatas = {
        page: 1,
        pageSize: this.datas.pageSize,
        id: this.datas.id,
        realname: this.datas.realname,
        ...data
      }
      this.datas = isDatas
      this.clientProductList();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 10,
        id: "",
        realname: "",
        CLIENT_ATTR: [],
        CLIENT_TYPE: [],
      };
      this.clientProductList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },

  },
};
</script>

<style lang='scss' scoped>
.search {
  margin-bottom: 24px;
  position: relative;

  .row {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 16px;

    .item {
      width: 180px;
      margin-right: 24px;
      margin-bottom: 10px;
    }
  }

  .operation {
    position: absolute;
    top: -85px;
    right: 0
  }
}

.advancedScreening {
  margin-bottom: 24px;


}

a {
  color: #000;
}

/deep/.el-textarea__inner {
  padding: 0;
  min-height: 100px !important;
}

/deep/.basicInfoPendingMaintenance {
  background: #F56C6C !important;
  color: #000 !important;
}

/deep/.managementNumberCount {
  background: #409EFF !important;
  color: #000 !important;
}

/deep/.maintainedBasicInfo {
  background: #67C23A !important;
  color: #000 !important;
}
</style>
